"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqDataFromJSON = FaqDataFromJSON;
exports.FaqDataFromJSONTyped = FaqDataFromJSONTyped;
exports.FaqDataToJSON = FaqDataToJSON;
exports.FaqDataToJSONTyped = FaqDataToJSONTyped;
const _1 = require("./");
function FaqDataFromJSON(json) {
    return FaqDataFromJSONTyped(json, false);
}
function FaqDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'incidentBanner': json['incidentBanner'],
        'topics': (json['topics'].map(_1.FaqTopicFromJSON)),
    };
}
function FaqDataToJSON(value) {
    return FaqDataToJSONTyped(value, false);
}
function FaqDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'incidentBanner': value.incidentBanner,
        'topics': (value.topics.map(_1.FaqTopicToJSON)),
    };
}
